var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EditLayout',{attrs:{"title":"Edit contact","breadcrumbs":_vm.pBreadcrumbs}},[_c('AddUpdateContact',{ref:"AddUpdateContact",attrs:{"btnText":"Save Contact","formHandler":_vm.formHandler,"dataLoading":_vm.loading,"isEmailDisabled":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }